"use client";

import { FC } from "react";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import Bounded from "@/components/componentsV2/shared-components/Bounded";
import ServiceCard from "@/app/(landing)/employability/components/service-card";
import { motion } from 'framer-motion'

/**
 * Props for `AdditionalServicesSection`.
 */
export type AdditionalServicesSectionProps =
  SliceComponentProps<Content.AdditionalServicesSectionSlice>;

/**
 * Component for "AdditionalServicesSection" Slices.
 */
const AdditionalServicesSection: FC<AdditionalServicesSectionProps> = ({
  slice,
}) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {slice.variation === "default" ? (
        <>
          <Bounded className="bg-[#F8FCFF] py-[60px] xl:py-[40px]">
            {/* heading */}
            <motion.div initial={{ y: 30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.4, ease: "easeInOut", delay: 0.3 }}
                  viewport={{ once: true }}>
              <PrismicRichText
                field={slice.primary.heading}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="text-primary text-5xl leading-[1.33] font-semibold md:text-center">
                      {children}
                    </h1>
                  ),
                  heading2: ({ children }) => (
                    <h2 className="text-primary text-5xl leading-[1.33] font-semibold md:text-center">
                      {children}
                    </h2>
                  ),
                  heading3: ({ children }) => (
                    <h3 className="text-primary text-5xl leading-[1.33] font-semibold md:text-center">
                      {children}
                    </h3>
                  ),
                  heading4: ({ children }) => (
                    <h4 className="text-primary text-5xl leading-[1.33] font-semibold md:text-center">
                      {children}
                    </h4>
                  ),
                  heading5: ({ children }) => (
                    <h5 className="text-primary text-5xl leading-[1.33] font-semibold md:text-center">
                      {children}
                    </h5>
                  ),
                  heading6: ({ children }) => (
                    <h6 className="text-primary text-5xl leading-[1.33] font-semibold md:text-center">
                      {children}
                    </h6>
                  ),
                  label: ({ node, children }) => {
                    if (node.data.label === "Highlight") {
                      return <span className="text-secondary">{children}</span>;
                    }
                  },
                }}
              />
            </motion.div>

            {/* services */}

            {slice.primary.services.map((item, index) => (
              <ServiceCard key={index} service={item} />
            ))}
          </Bounded>
        </>
      ) : null}
    </section>
  );
};

export default AdditionalServicesSection;
